import { render } from "./GeneralLedger.vue?vue&type=template&id=6a5a2d11"
import script from "./GeneralLedger.vue?vue&type=script&lang=js"
export * from "./GeneralLedger.vue?vue&type=script&lang=js"

import "./GeneralLedger.vue?vue&type=style&index=0&id=6a5a2d11&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Accounting/GeneralLedger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a5a2d11"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a5a2d11', __exports__)) {
    api.reload('6a5a2d11', __exports__)
  }
  
  module.hot.accept("./GeneralLedger.vue?vue&type=template&id=6a5a2d11", () => {
    api.rerender('6a5a2d11', render)
  })

}


export default __exports__